import { createApiResource, UnpagedListResource } from '../apiResourceFactory';
import { ServiceTitanAPI } from '../apiService';
import { ServiceTitanZone, ServiceTitanZoneQueryParams } from '../apiTypes.shim';

type ServiceTitanZoneResource = UnpagedListResource<ServiceTitanZone, ServiceTitanZoneQueryParams>;

export const createServiceTitanZoneResource = (companyId: string): ServiceTitanZoneResource => {
  const zoneUri = `${companyId}/zones`;
  const { useUnpagedList, unpagedList, unpagedListQueryKey } = createApiResource(ServiceTitanAPI, zoneUri);

  return {
    useUnpagedList,
    unpagedList,
    unpagedListQueryKey
  };
};
